import Vue from 'vue';
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify);

export default new Vuetify({
    iconfont: 'mdi',
    theme: {
        themes: {
            light: {
                background: '#FFFFFF',
                primary: "#4d4d4d",
                secondary: '#eac655'
            }
        }
    }
});
